import DebtorList from '../components/debtor/List.vue';
import DebtorCreate from '../components/debtor/Create.vue';
import DebtorUpdate from '../components/debtor/Update.vue';
import DebtorShow from '../components/debtor/Show.vue';

export default [
  { name: 'DebtorList', path: '/debtors/', component: DebtorList },
  { name: 'DebtorCreate', path: '/debtors/create', component: DebtorCreate },
  { name: 'DebtorUpdate', path: "/debtors/edit/:id", component: DebtorUpdate },
  { name: 'DebtorShow', path: "/debtors/show/:id", component: DebtorShow  }
];



// WEBPACK FOOTER //
// ./src/routes/debtor.js